import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Landmark, Percent, CalendarClock, Scale } from "lucide-react";
import { AggHeader, ResetSampleButton, TabBar } from "./aggKit";
import RevenueMatrix from "./fin/RevenueMatrix";
import PaymentCycles from "./fin/PaymentCycles";
import WeightRecon from "./fin/WeightRecon";

const TABS = [["matrix", "Revenue-sharing matrix", Percent], ["cycles", "Payment cycle logs", CalendarClock], ["recon", "Weight reconciliation", Scale]];

export default function AggFinancePage() {
  const [params, setParams] = useSearchParams();
  const tab = TABS.some(([k]) => k === params.get("tab")) ? params.get("tab") : "matrix";
  const [tick, setTick] = useState(0);
  return (
    <div className="space-y-4" data-testid="agg-finance-page">
      <AggHeader icon={Landmark} title="Financial & Commission Management"
        subtitle="Commission rules, MSME COD and franchise payout cycles, and carrier weight-dispute reconciliation."
        actions={<ResetSampleButton onDone={() => setTick((t) => t + 1)} />} />
      <TabBar tabs={TABS} value={tab} onChange={(k) => setParams({ tab: k }, { replace: true })} testid="fin-tabs" />
      {tab === "matrix" && <RevenueMatrix tick={tick} />}
      {tab === "cycles" && <PaymentCycles tick={tick} />}
      {tab === "recon" && <WeightRecon tick={tick} />}
    </div>
  );
}
